import {useEffect, useMemo} from "react";
import {optional, types, validateArgs} from "@soap/modules";

export function useQueryString() {
    const location = window.location;
    const search = (id) => {
        return new URLSearchParams(location.search).get(id);
    };
    
    return useMemo(() => {
        return ({
            search
        });
    }, [location]);
}

export function useQueryResponse(queryResponse, responseAction) {

    validateArgs(
        [{queryResponse}, types.object, optional],
        [{responseAction}, types.function],
    );
    
    useEffect(() => {
        if (queryResponse) {
            responseAction(queryResponse);
        }
    }, [queryResponse]);
}

